import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import type { TiptapFormValues } from "@/react/components/CommentsCompass/types";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { commentCache } from "@/react/lib/queries/comments";
import type { Comment } from "@/react/types/Comment";

interface UseCreateCommentParams {
  onSuccess: (comment: Comment) => void;
  parentCommentId?: number;
  postId: number;
}

export const useCreateComment = ({
  postId,
  parentCommentId,
  onSuccess,
}: UseCreateCommentParams) => {
  const { error } = useToast();

  const { mutateAsync: createComment } = useMutation({
    mutationFn: (commentData: TiptapFormValues) =>
      reactQueryPost<Comment>(internalApi.comments.create({ postId }), {
        comment: { parent_comment_id: parentCommentId, ...commentData },
      }),
    onSuccess: comment => {
      commentCache.add({ postId, parentCommentId, comment });
      onSuccess(comment);
    },
    onError: () => error(t("comments.create.alerts.failure")),
  });

  return { createComment };
};
